import React from "react";
import { useTranslation } from "react-i18next";

import { Checkbox } from "@common/checkbox";
import { Props } from "../types";
import { AccessInput } from "../accessInput";
import { NameInput } from "../nameInput";
import styles from "./styles.scss";

function TextForm({ formData, type, edit, isOption }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.form}>
      <div className={styles.group}>
        <NameInput
          value={formData}
          input={(value) => edit({ ...formData, ...value })}
        />
      </div>
      {!isOption && (
        <>
          {type === "project" && (
            <div
              className={styles.attribute}
              onClick={() =>
                edit({
                  ...formData,
                  attr: {
                    ...formData.attr,
                    required:
                      formData.attr.required === "true" ? "false" : "true",
                  },
                })
              }
            >
              <Checkbox isChecked={formData.attr.required === "true"} />
              <p>{t("secondaryCriteriaTemplate.form.options.required")}</p>
            </div>
          )}
          <div className={styles.group}>
            <AccessInput
              value={formData.accessRoles}
              input={(accessRoles) => edit({ ...formData, accessRoles })}
            />
          </div>
        </>
      )}
    </div>
  );
}

export { TextForm };
